import styled from "styled-components";

export const PopupStyled = styled.div`
  svg {
    width: 30px;
    height: 30px;
    stroke: #000;
    fill: transparent;
    transition: all 0.3s ease 0s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
  }
  .inner-popup__payment {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
